import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectHeaderTabDS } from '@EUForms/selectors'
import { resetForm } from './reducer/headerSlice'

const DmsEuHeader = ({ shipmentId, renderEuHeader }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        return () => dispatch(resetForm());
    }, [shipmentId])
    const emergencyProcedure = useSelector(selectHeaderTabDS)?.emergencyProcedure || ''
    return renderEuHeader && renderEuHeader({ emergencyProcedure })
}

export default DmsEuHeader